import { atom, type PrimitiveAtom } from 'jotai'
import { atomWithStorage, createJSONStorage } from 'jotai/utils'
import { getUserCollectionCompanyId, getUserMunicipalityId } from './helpers'

const storage = createJSONStorage<number | null>(() => sessionStorage)

const initialMunicipalityId = getUserMunicipalityId()
const initialCollectionCompanyId = getUserCollectionCompanyId()

export const selectedCollectionCompanyIdAtom = atomWithStorage<number | null>('collectionCompanyId', initialCollectionCompanyId, storage)

export const selectedMunicipalityIdAtom = atomWithStorage<number | null>('municipalityId', initialMunicipalityId, storage)

export const selectedCollectionPointIdAtom = atomWithStorage<number | null>('collectionPointId', null, storage)

export const householdsExportIdAtom = atom<number | null>(null) as PrimitiveAtom<number | null>
export const householdMembersExportIdAtom = atom<number | null>(null) as PrimitiveAtom<number | null>

export const feePayersGenerationIdAtom = atom<number | null>(null) as PrimitiveAtom<number | null>
export const yearlyFeePaymentsGenerationIdAtom = atom<number | null>(null) as PrimitiveAtom<number | null>
export const sendYearlyFeePaymentEmailsIdAtom = atom<number | null>(null) as PrimitiveAtom<number | null>

export const discountAssignInMunicipalityJobIdAtom = atom<number | null>(null) as PrimitiveAtom<number | null>
